export enum TwoFactorAuthenticationContext {
  AUTHENTICATION = 'authentication',
  RECOVERY_PASSWORD = 'recoverPassword',
  SIGNATURE = 'signature',
}
